import { AnyAction, combineReducers } from '@reduxjs/toolkit'
import { reducer as formReducer } from 'redux-form'

import { claimReducer } from './claim/claim-reducers'
import { notificationReducer } from './notifications/notifications-reducers'
import type { GlobalState } from './types'
import { upload, uploadErrors } from './upload/upload-reducers'


const KILL_STATE = 'KILL_STATE'

export const killState = () => ({ type: KILL_STATE })

const AppReducer = combineReducers({
  claim: claimReducer,
  upload,
  uploadErrors,
  notifications: notificationReducer,
  form: formReducer
})

const rootReducer = (state: GlobalState | undefined, action: AnyAction) => {
  if (action.type === KILL_STATE) {
    state = undefined
  }

  return AppReducer(state, action)
}

export { rootReducer }
